inheritedContext